import { useState } from 'react';
import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';
import { isValidFormat } from 'helpers/PdfFunction';

import { updateForm } from 'store/Writer/Analyser';

export const useWriterTextSave = ({
  formData,
  initialHtmlContent,
  initialTextContent,
  actualTextContent,
  actualTextWordCount,
  initialTextWordCount,
  combinedKeywords,
  keyword,
  metaDescriptionTag,
  textTitle,
  titleTag,
  url,
  textType,
  stuffedKeywords,
  websites,
  initialStuffedKeywords,
  analyseResult,
  orderId,
  setConfirmation,
  setActualTextContent,
  setActualHtmlContent,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setErrorSuccess,
  t,
}) => {
  const dispatch = useDispatch();

  const [isTextFieldDisabled, setIsTextFieldDisabled] = useState(false);

  const handleSave = () => {
    const isKeywordsValid =
      textType !== 'TRANSLATED' ? isValidFormat(combinedKeywords) : {};

    const requestData = {
      activeInitialText: false,
      actualHtmlContent: initialHtmlContent,
      actualTextContent: initialTextContent,
      analyseResult: analyseResult && JSON.stringify(formData?.analyseResult),
      initialHtmlContent: initialHtmlContent,
      initialTextContent: initialTextContent,
      keyword: keyword,
      metaDescriptionTag: metaDescriptionTag,
      semanticGap: isKeywordsValid
        ? transformToSemanticGap(combinedKeywords)
        : null,
      textTitle: textTitle,
      titleTag: titleTag,
      totalNumberOfTextAdded:
        actualTextContent && textType === 'NON_TRANSLATED'
          ? actualTextWordCount - initialTextWordCount
          : actualTextWordCount,

      url: url,
      type: textType,
      stuffedKeywords: stuffedKeywords,
      internalLinking: websites,
      initialStuffedKeywords: initialStuffedKeywords,
    };

    const handleSuccess = (res) => {
      dispatch(updateForm(res.data));
      setIsTextFieldDisabled(true);
      setConfirmation(false);
      setActualTextContent(initialTextContent);
      setActualHtmlContent(initialHtmlContent);

      const successMsg = {
        TRANSLATED: t('La traduction a été enregistrée avec succès'),
        COMBINED: t('Texte + Traduction enregistré avec succès'),
        DEFAULT: t('Le texte a été enregistré avec succès'),
      };

      setErrorSuccessMsg(`${successMsg[textType] || successMsg.DEFAULT}!`);

      setErrorSuccessImg(animationUrl + '/05_Contenu_livré.gif');
      setIsSuccess(true);
      setErrorSuccess(true);
    };

    const handleError = (e) => {
      switch (e.response.status) {
        case 400:
          setErrorSuccessMsg(
            `${t(
              'Veuillez changer les informations suivantes titre et/ou mot clé'
            )}`
          );
          break;
        default:
          setErrorSuccessMsg(`Oups...! ${t("Une erreur s'est produite")}. `);
          break;
      }
      setIsSuccess(false);
      setErrorSuccess(true);
    };

    if (formData) {
      axiosPrivate
        .put(`/texts/${formData.id}`, requestData)
        .then((res) => handleSuccess(res))
        .catch((e) => handleError(e));
    } else {
      const postData = {
        ...requestData,
        commandId: orderId,
      };

      axiosPrivate
        .post('/texts', postData)
        .then((res) => handleSuccess(res))
        .catch(() => {
          setErrorSuccessMsg(`Oups...! ${t("Une erreur s'est produite")}. `);
          setIsSuccess(false);
          setErrorSuccess(true);
        });
    }
  };

  return { handleSave, isTextFieldDisabled };
};
